<div class="gcontainer bwhite">
  <div class="row">
    <div class="row search-row">
      <div class="col-md-8">
        <nav aria-label="breadcrumb" class="mt-8">
          <ol class="breadcrumb">
            <li
              class="breadcrumb-item active breadcrumb cursor"
              aria-current="page"
              (click)="reDirectUrl()"
              (keypress)="reDirectUrl()"
              tabindex="0">
              Dashboard
            </li>
            <li class="breadcrumb-item active" aria-current="page">Mix Design Dashboard</li>
          </ol>
        </nav>
      </div>
      <div class="col-md-4 search-section">
        <mat-form-field appearance="outline" floatLabel="always">
          <input
            class="search-text"
            matInput
            [(ngModel)]="searchValue"
            (keyup)="applyFilter($event)"
            placeholder="Search"
            />
            @if (!searchValue) {
              <mat-icon matSuffix class="search-icon">search</mat-icon>
            }
            @if (searchValue) {
              <button
                mat-icon-button
                matSuffix
                aria-label="Clear"
                (click)="clearSearch()"
                >
                <mat-icon>close</mat-icon>
              </button>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-md-3">
          <h1 class="mat-h1">Mix Design Dashboard</h1>
        </div>
        <div class="col-md-9 text-end new-mix-design">
          <button mat-raised-button color="primary" class="new-client-mix-design" (click)="createClientMixDesign()">
            Add Client Provided Mix Design
          </button>
          <button mat-raised-button (click)="createGeothermMixDesign()">
            Create Geotherm Mix Design
          </button>
        </div>
      </div>

      <div class="table-wrapper">
        <table mat-table [dataSource]="dataSource" class="mat-table" multiTemplateDataRows>
          <ng-container matColumnDef="id" hidden>
            <th mat-header-cell *matHeaderCellDef>Id</th>
            <td mat-cell *matCellDef="let mixDesign"> {{ mixDesign.id }} </td>
          </ng-container>

          <ng-container matColumnDef="mixReferenceId">
            <th mat-header-cell *matHeaderCellDef>Reference</th>
            <td mat-cell *matCellDef="let mixDesign"> {{ mixDesign.mixReferenceId }} </td>
          </ng-container>

          <ng-container matColumnDef="designedByGeotherm">
            <th mat-header-cell *matHeaderCellDef> Designed By </th>
            <td mat-cell *matCellDef="let mixDesign">
              {{ mixDesign.designedByGeotherm ? 'Geotherm' : 'Client' }}
              @if (mixDesign.geothermMixId) {
                <img
                  src="/assets/icons/arrow.svg"
                  alt="mix-design-dashboard"
                  (click)="navigate(mixDesign.geothermMixId)"
                  class="mix-design-link-icon" />
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="mixId">
            <th mat-header-cell *matHeaderCellDef>Mix ID</th>
            <td mat-cell *matCellDef="let mixDesign">
              <a href="javascript:void(0)" class="mix-link" (click)="onMixDesignClick(mixDesign)">
                {{ mixDesign.mixId }}
              </a>
            </td>
          </ng-container>

          <ng-container matColumnDef="companyName">
            <th mat-header-cell *matHeaderCellDef>Company Name</th>
            <td mat-cell *matCellDef="let mixDesign"> {{ mixDesign.companyName }} </td>
          </ng-container>

          <ng-container matColumnDef="projectName">
            <th mat-header-cell *matHeaderCellDef>Project Name</th>
            <td mat-cell *matCellDef="let mixDesign"> {{ mixDesign.projectName }} </td>
          </ng-container>

          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>Date</th>
            <td mat-cell *matCellDef="let mixDesign">
              {{ mixDesign.date | date:'MMM d, y' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="location">
            <th mat-header-cell *matHeaderCellDef>Location</th>
            <td mat-cell *matCellDef="let mixDesign"> {{ mixDesign.location }} </td>
          </ng-container>

          <ng-container matColumnDef="city">
            <th mat-header-cell *matHeaderCellDef>City</th>
            <td mat-cell *matCellDef="let mixDesign"> {{ mixDesign.city }} </td>
          </ng-container>

          <ng-container matColumnDef="state">
            <th mat-header-cell *matHeaderCellDef>State</th>
            <td mat-cell *matCellDef="let mixDesign"> {{ mixDesign.state }} </td>
          </ng-container>

          <ng-container matColumnDef="country">
            <th mat-header-cell *matHeaderCellDef>Country</th>
            <td mat-cell *matCellDef="let mixDesign"> {{ mixDesign.country }} </td>
          </ng-container>

          <ng-container matColumnDef="materialType">
            <th mat-header-cell *matHeaderCellDef>Material Type</th>
            <td mat-cell *matCellDef="let mixDesign"> {{ mixDesign.materialType }} </td>
          </ng-container>

          <ng-container matColumnDef="strength">
            <th mat-header-cell *matHeaderCellDef style="text-align: center;">
              Strength <span class="unit-text">(psi)</span>
            </th>
            <td mat-cell *matCellDef="let mixDesign" style="text-align: center;">
              {{ mixDesign.strength }}
            </td>
          </ng-container>

          <ng-container matColumnDef="slump">
            <th mat-header-cell *matHeaderCellDef style="text-align: center;">
              Slump <span class="unit-text">(inches)</span>
            </th>
            <td mat-cell *matCellDef="let mixDesign" style="text-align: center;">
              {{ mixDesign.slump }}
            </td>
          </ng-container>

          <ng-container matColumnDef="timeOfEfflux">
            <th mat-header-cell *matHeaderCellDef style="text-align: center;">
              Time of Efflux <span class="unit-text">(seconds)</span>
            </th>
            <td mat-cell *matCellDef="let mixDesign" style="text-align: center;">
              {{ mixDesign.timeOfEfflux }}
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef style="text-align: right; padding-right: 60px; width: 180px;">Actions</th>
            <td mat-cell *matCellDef="let mixDesign" style="text-align: right;">
              <button mat-icon-button style="color: gray;" (click)="editMixDesign(mixDesign)">
                <mat-icon style="font-size: 20px;">edit</mat-icon>
              </button>
              <button mat-icon-button style="color: gray;" (click)="copyRow(mixDesign)">
                <mat-icon style="font-size: 20px;">file_copy</mat-icon>
              </button>
              <button mat-icon-button style="color: gray;" (click)="removeRow(mixDesign)">
                <mat-icon style="font-size: 20px;">delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </div>
  </div>

